// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog[data-v-7bd4a222]  .modal-body{width:420px;padding:30px 20px}.title[data-v-7bd4a222]{font-size:1.28571rem;line-height:1.57143rem;color:#000;margin:0 auto 20px;text-align:center}.textarea[data-v-7bd4a222]{margin-bottom:20px}.textarea[data-v-7bd4a222]  textarea{min-height:150px}.btns-wrapper[data-v-7bd4a222]{width:100%;display:flex;flex-direction:row;align-items:center;justify-content:space-between}.btns-wrapper .btn[data-v-7bd4a222]{width:144px}", ""]);
// Exports
module.exports = exports;
